import React from 'react';
import { IconCrown, IconKeyGold, IconKeySilver } from '../../../base/icons/svg';
import BaseIndicator from '../../../base/react/components/web/BaseIndicator';
import { ROLE_PARTICIPANT_ROOM } from '../../../base/constants/default';
/**
 * React {@code Component} for showing a moderator icon with a tooltip.
 *
 * @returns {JSX.Element}
 */
const ModeratorIndicator = ({ tooltipPosition, role }) => {
    let icon = IconKeySilver;
    if (role === ROLE_PARTICIPANT_ROOM.OWNER)
        icon = IconCrown;
    if (role === ROLE_PARTICIPANT_ROOM.HOST)
        icon = IconKeyGold;
    return (React.createElement(BaseIndicator, { icon: icon, iconSize: 20, tooltipKey: `menuController.${role}`, tooltipPosition: tooltipPosition }));
};
export default ModeratorIndicator;
